module.exports = new Promise((resolve) => {
    const module = {
        get: (request) => window.host.get(request),
        init: (arg) => {
            // Внешнего host (core-ui) на странице нет
            if (!window.host) {
                return console.warn('Host container is not present (standalone mode)');
            }
            try {
                return window.host.init(arg);
            }
            catch (e) {
                // host есть, но .init() уже вызывался раньше
                console.warn('Host has already been loaded', e);
            }
        },
    };
    resolve(module);
});